import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Shield } from 'lucide-react';
import { Navbar } from '../components/layout/Navbar';
import { useLanguage } from '../hooks/useLanguage';
export function PrivacyPolicyPage() {
  const {
    language
  } = useLanguage();
  const isRTL = language === 'ar';
  return <div className="min-h-screen bg-gray-50" dir={isRTL ? 'rtl' : 'ltr'} data-id="element-2908">
      <Navbar data-id="element-2909" />

      <div className="max-w-4xl mx-auto px-4 py-12" data-id="element-2910">
        <Link to="/" className="inline-flex items-center gap-2 text-[#4f1964] hover:text-[#3d1350] mb-8 transition-colors" data-id="element-2911">
          <ArrowLeft className={`w-4 h-4 ${isRTL ? 'rotate-180' : ''}`} data-id="element-2912" />
          <span data-id="element-2913">{isRTL ? 'العودة للرئيسية' : 'Back to Home'}</span>
        </Link>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-white rounded-2xl shadow-lg p-8 md:p-12" data-id="element-2914">
          <div className="flex items-center gap-4 mb-8" data-id="element-2915">
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center" data-id="element-2916">
              <Shield className="w-8 h-8 text-[#4f1964]" data-id="element-2917" />
            </div>
            <div data-id="element-2918">
              <h1 className="text-3xl font-bold text-gray-900" data-id="element-2919">
                {isRTL ? 'سياسة الخصوصية' : 'Privacy Policy'}
              </h1>
              <p className="text-gray-500 mt-1" data-id="element-2920">
                {isRTL ? 'آخر تحديث: يناير 2025' : 'Last updated: January 2025'}
              </p>
            </div>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-2921">
            {isRTL ? <>
                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2922">
                  مقدمة
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2923">
                  في Operines، نحن ملتزمون بحماية خصوصيتك وأمان بياناتك. توضح
                  سياسة الخصوصية هذه كيفية جمع واستخدام وحماية معلوماتك الشخصية
                  عند استخدام منصتنا.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2924">
                  المعلومات التي نجمعها
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2925">
                  نقوم بجمع الأنواع التالية من المعلومات:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2926">
                  <li data-id="element-2927">معلومات الحساب: الاسم، البريد الإلكتروني، رقم الهاتف</li>
                  <li data-id="element-2928">معلومات الأعمال: اسم النشاط التجاري، الفئة، الوصف</li>
                  <li data-id="element-2929">بيانات الاستخدام: كيفية تفاعلك مع منصتنا</li>
                  <li data-id="element-2930">معلومات تقنية: عنوان IP، نوع المتصفح، نظام التشغيل</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2931">
                  كيف نستخدم معلوماتك
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2932">
                  نستخدم معلوماتك من أجل:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2933">
                  <li data-id="element-2934">تقديم وتحسين خدماتنا</li>
                  <li data-id="element-2935">التواصل معك بشأن حسابك والتحديثات</li>
                  <li data-id="element-2936">معالجة المعاملات والفواتير</li>
                  <li data-id="element-2937">تخصيص تجربتك</li>
                  <li data-id="element-2938">ضمان أمان المنصة ومنع الاحتيال</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2939">
                  مشاركة البيانات
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2940">
                  نحن لا نبيع معلوماتك الشخصية. قد نشارك بياناتك مع مزودي خدمات
                  موثوقين يساعدوننا في تشغيل منصتنا، مثل خدمات الاستضافة ومعالجة
                  الدفع، وذلك فقط بالقدر اللازم لتقديم خدماتنا.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2941">
                  أمان البيانات
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2942">
                  نستخدم تدابير أمنية متقدمة لحماية معلوماتك، بما في ذلك التشفير
                  والتخزين الآمن وضوابط الوصول. ومع ذلك، لا يمكن لأي طريقة نقل
                  عبر الإنترنت أن تكون آمنة بنسبة 100%.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2943">
                  حقوقك
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2944">
                  لديك الحق في:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2945">
                  <li data-id="element-2946">الوصول إلى بياناتك الشخصية</li>
                  <li data-id="element-2947">تصحيح المعلومات غير الدقيقة</li>
                  <li data-id="element-2948">طلب حذف بياناتك</li>
                  <li data-id="element-2949">الاعتراض على معالجة بياناتك</li>
                  <li data-id="element-2950">طلب نقل البيانات</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2951">
                  الاتصال بنا
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2952">
                  إذا كانت لديك أي أسئلة حول سياسة الخصوصية هذه، يرجى الاتصال
                  بنا على:
                  <br data-id="element-2953" />
                  <a href="mailto:hello@operines.ai" className="text-[#4f1964] hover:underline font-medium" data-id="element-2954">
                    hello@operines.ai
                  </a>
                </p>
              </> : <>
                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2955">
                  Introduction
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2956">
                  At Operines, we are committed to protecting your privacy and
                  securing your data. This Privacy Policy explains how we
                  collect, use, and safeguard your personal information when you
                  use our platform.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2957">
                  Information We Collect
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2958">
                  We collect the following types of information:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2959">
                  <li data-id="element-2960">Account Information: Name, email, phone number</li>
                  <li data-id="element-2961">
                    Business Information: Business name, category, description
                  </li>
                  <li data-id="element-2962">Usage Data: How you interact with our platform</li>
                  <li data-id="element-2963">
                    Technical Information: IP address, browser type, operating
                    system
                  </li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2964">
                  How We Use Your Information
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2965">
                  We use your information to:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2966">
                  <li data-id="element-2967">Provide and improve our services</li>
                  <li data-id="element-2968">Communicate with you about your account and updates</li>
                  <li data-id="element-2969">Process transactions and billing</li>
                  <li data-id="element-2970">Personalize your experience</li>
                  <li data-id="element-2971">Ensure platform security and prevent fraud</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2972">
                  Data Sharing
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2973">
                  We do not sell your personal information. We may share your
                  data with trusted service providers who help us operate our
                  platform, such as hosting and payment processing services,
                  only to the extent necessary to provide our services.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2974">
                  Data Security
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2975">
                  We use industry-standard security measures to protect your
                  information, including encryption, secure storage, and access
                  controls. However, no method of transmission over the internet
                  can be 100% secure.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2976">
                  Your Rights
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2977">
                  You have the right to:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2978">
                  <li data-id="element-2979">Access your personal data</li>
                  <li data-id="element-2980">Correct inaccurate information</li>
                  <li data-id="element-2981">Request deletion of your data</li>
                  <li data-id="element-2982">Object to data processing</li>
                  <li data-id="element-2983">Request data portability</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2984">
                  Contact Us
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2985">
                  If you have any questions about this Privacy Policy, please
                  contact us at:
                  <br data-id="element-2986" />
                  <a href="mailto:hello@operines.ai" className="text-[#4f1964] hover:underline font-medium" data-id="element-2987">
                    hello@operines.ai
                  </a>
                </p>
              </>}
          </div>
        </motion.div>
      </div>
    </div>;
}